import React from 'react';
import './index.css';

function dayDiff(timeStamp) {
    if (timeStamp != undefined) {
        return timeStamp.substring(0, 10);
    }
}

function facts(props) {
    return (
        <>
            <div className="facts" >
                <h4 className="fact_claim" style={{ marginBottom: '20px' }}>Claim by {props.claimant} :</h4>
                <span className="fact_text" style={{ marginLeft: '20px', marginBottom: '20px' }}>{props.text}</span>
                <h4 className="fact_rating" style={{ marginLeft: '20px', marginBottom: '20px' }}>Rating: {props.textualRating}</h4>
                <a href={props.url} target="_blank" style={{ color: '#4083f3', marginLeft: '20px', marginBottom: '20px' }}>
                    Read Article
                </a><br />
                <span style={{ color: '#9e9e9e', fontSize: '12px', marginLeft: '20px', marginBottom: '20px' }}>{dayDiff(props.reviewDate)}</span>
            </div>
        </>
    );
}

export default facts;